import { PLATFORM_MARK_URL, isPlatformBrand, useBrandStore } from '@/brand'
import { cn } from '@/design'

const SIZE = {
  sm: 'size-8 text-[15px] rounded-[8px]',
  md: 'size-[34px] text-[17px] rounded-[9px]',
  lg: 'size-14 text-[26px] rounded-[14px]',
} as const

/**
 * The square mark: the tenant's logo, the RecoupSlots calendar glyph for the platform brand, or a
 * single letter on the accent gradient. `onDark` puts an image mark on a white tile so the navy
 * glyph stays visible on the navy sidebar; the image is never stretched (object-contain).
 */
export function BrandMark({
  size = 'md',
  onDark = false,
  className,
}: {
  readonly size?: keyof typeof SIZE
  readonly onDark?: boolean
  readonly className?: string
}) {
  const brand = useBrandStore((state) => state.brand)
  const ownLogo = brand.logo_asset_url !== null && brand.logo_asset_url !== ''
  const src = ownLogo ? brand.logo_asset_url : isPlatformBrand(brand) ? PLATFORM_MARK_URL : null
  if (src !== null) {
    return (
      <img
        src={src}
        alt={`${brand.product_name} logo`}
        className={cn('shrink-0 object-contain', SIZE[size], onDark && 'bg-white p-0.5', className)}
      />
    )
  }
  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center bg-[linear-gradient(135deg,var(--brand-accent),color-mix(in_srgb,var(--brand-accent)_70%,black))] font-display font-bold text-accent-fg',
        SIZE[size],
        className,
      )}
    >
      {brand.logo_mark_letter}
    </span>
  )
}
